import { fromJS } from "immutable";
import { MrReduxCrud } from "mr_react_framework";
import { axiosInstance } from "api/apiModule";
import { message } from "components/UI/AntdAppHelper";
import OfflineAppService from "lib/utils/offlineAppService";
import { delay, put } from "redux-saga/effects";
// console.log( "OfflineAppService", OfflineAppService );
const reduxCrud = new MrReduxCrud({
  axiosInstance,
  resourceName: "offline_app",
  message,
  actionNames: ["EXECUTE_METHOD"]
});

export function* executeMethodSaga(action) {
  const {payload, options={}} = action;
  let executeMethodArr = [];
  let executeMethodArgs;
  
  if(Array.isArray(payload)){
    executeMethodArr = payload;
  } else {
    executeMethodArgs = {
      key: payload.key,
      value: payload.value
    };
  }
  // let url = "sessions.json";
  try {
    yield put(actions.executeMethodStart());
    if(executeMethodArr.length > 0){

      for(var element of executeMethodArr){  
        try {
          console.log("execute methods ==>", executeMethodArr, executeMethodArr.length)
          let finalResponse = yield OfflineAppService.executeAppMethod(element);
          if(!finalResponse){
            finalResponse = element.value;
          }
          yield delay(1);
          // yield localStorage.setItem("token", response.data.token);
          yield put(actions.executeMethodSuccess({key: element.key, response: finalResponse}));  
        } catch (error) {
          // Failing even if one fails
          console.log( "executeMethodFail error", error );

          // HACK to fix - TODO: closeallapps is timing out - need to fix this. not triggering alert error for now
          if(element.key !== "closeAllApps"){
            yield put(actions.executeMethodFail({error: error}));
          }
        }
        
      };
      
    } else {
      const response = yield OfflineAppService.executeAppMethod(executeMethodArgs);
      console.log( "executeMethodStart", response );
      let finalResponse = response;
      if(!finalResponse){
        finalResponse = payload.value;
      }
      // yield localStorage.setItem("token", response.data.token);
      yield put(actions.executeMethodSuccess({key: payload.key, response: finalResponse}));
    }
    if(options.successCallback){
      options.successCallback()
    }
  } catch (error) {
    console.log( "executeMethodFail error", error );
    if(options.errorCallback){
      options.errorCallback()
    }
    yield put(actions.executeMethodFail({error: error}));
  }
}

// export function* executeMethodSaga(action) {
//   const {payload} = action;
//   const executeMethodArgs = {
//     key: payload.key,
//     value: payload.value
//   };
//   // let url = "sessions.json";
//   try {
//     yield put(actions.executeMethodStart());
//     const response = yield OfflineAppService.executeAppMethod(executeMethodArgs);
//     console.log( "executeMethodStart", response );
//     let finalResponse = response;
//     if(!finalResponse){
//       finalResponse = payload.value;
//     }
//     // yield localStorage.setItem("token", response.data.token);
//     yield put(actions.executeMethodSuccess({key: payload.key, response: finalResponse}));
//   } catch (error) {
//     console.log( "executeMethodFail error", error );
//     yield put(actions.executeMethodFail({error: error}));
//   }
// }

function executeMethodSuccess(state = initialState, action) {
  const {payload} = action;
  // TODO: update state here according to data
  console.log( "executeMethodSuccess", action );
  return state.set(payload.key, payload.response);
  // return state;
  // return state.set
}

const initialState = fromJS({
  offlineData: {},
  error: null,
  loading: false
});

export const actions = reduxCrud.getActions();
export const actionTypes = reduxCrud.getActionTypes();
export const reducer = reduxCrud.getReducer(initialState, {
  [actionTypes.EXECUTE_METHOD_OFFLINE_APP_SUCCESS]: executeMethodSuccess,
});
export const watchOfflineApp = reduxCrud.generateWatchSaga({
  [actionTypes.EXECUTE_METHOD_OFFLINE_APP]: executeMethodSaga
});
export default reduxCrud;